import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private idSnipper: string | undefined;
  private idSnipper2: string | undefined;
  ShowDialog(mensaje: string, tittle: string = 'Error'): void {
    mensaje = mensaje == null ? '' : mensaje;
    Metro.dialog.create({
      title: tittle,
      content: `<div style="min-width:300px;max-width: 600px;width:auto;">${mensaje}</div>`,
      actions: [
        {
          caption: 'Ok',
          onclick: function (el: any): void {
            $(el).data('dialog').close();
          },
        },
      ],
      options: {
        overlay: true,
        overlayColor: 'op-dark',
        overlayClickClose: true,
      },
    });
  }

  ShowConfirm(mensaje: string, tittle: string = 'Error'): Subject<boolean> {
    //Observable<boolean>
    let subject: Subject<boolean> = new Subject();
    Metro.dialog.create({
      title: `<div class="text-bold fg-brandColor2">${tittle}</div>`,
      content: mensaje,
      actions: [
        {
          caption: 'Ok',
          cls: 'success',
          onclick: function (el: any): void {
            $(el).data('dialog').close();
            // observable.
            subject.next(true);
          },
        },
        {
          caption: 'Cancel',
          cls: 'dark',
          onclick: function (el: any): void {
            $(el).data('dialog').close();
            subject.next(false);
          },
        },
      ],
      options: {
        // type: "success",
        overlay: true,
        overlayColor: 'op-dark',
        overlayClickClose: true,
      },
    });
    return subject;
  }

  ShowConfirmST(
    mensaje: string,
    tittle: string = 'Error',
    subtitle: string = ''
  ): Subject<boolean> {
    //Observable<boolean>
    let subject: Subject<boolean> = new Subject();
    Metro.dialog.create({
      title: `<div class="text-bold fg-brandColor2">${tittle}</div><div class="fg-brandColor2 text-secondary">${subtitle}</div>`,
      content: mensaje,
      actions: [
        {
          caption: 'Ok',
          cls: 'success',
          onclick: function (el: any): void {
            $(el).data('dialog').close();
            // observable.
            subject.next(true);
          },
        },
        {
          caption: 'Cancel',
          cls: 'dark',
          onclick: function (el: any): void {
            $(el).data('dialog').close();
            subject.next(false);
          },
        },
      ],
      options: {
        // type: "success",
        overlay: true,
        overlayColor: 'op-dark',
        overlayClickClose: true,
      },
    });
    return subject;
  }

  ShowConfirm2(mensaje: string, tittle: string = 'Error'): Subject<boolean> {
    //Observable<boolean>
    let subject: Subject<boolean> = new Subject();
    var dialog = Metro.dialog.create({
      title: `<div class="text-bold fg-brandColor2">${tittle}</div>`,
      //<div class="overlay" style="background: rgba(0, 0, 0, 0.2);"></div>
      content: mensaje,
      actions: [
        {
          caption: 'Ok',
          cls: 'success',
          onclick: function (el: any): void {
            $(el).data('dialog').close();
            // observable.
            subject.next(true);
          },
        },
        {
          caption: 'Cancel',
          cls: 'dark',
          onclick: function (el: any): void {
            $(el).data('dialog').close();
            subject.next(false);
          },
        },
      ],
      options: {
        // type: "success",
        //zIndex: 1,
        overlay: true,
        overlayColor: 'op-dark',
        overlayAlpha: 1,
        overlayClickClose: true,
      },
    });
    $(dialog[0]).addClass('zIndexConfirmClass');
    return subject;
  }

  Snniper2(): void {
    if (this.idSnipper2 === void 0) {
      var dialog: any = Metro.dialog.create({
        //  title: "",
        content: `<div class="" style="width: 60px; height: 50px; justify-content: center; align-items: center">
        <div data-role="activity" data-type="ring" data-style="color"></div>
        </div><div class="overlay" style="background: rgba(0, 0, 0, 0.2);"></div>`, //Favor, espere...
        //<div data-role="activity" data-type="cycle" data-style="color">Favor, espere...</div>
        /**/
        width: 110,
        defaultAction: false,
        //actions: []
        options: {
          overlay: true,
          overlayColor: 'op-dark', //,
          //overlayAlpha: 1
          //overlayClickClose: true
        },
      });
      $(dialog[0]).addClass('spinnerClass');
      this.idSnipper2 = $(dialog['0']).attr('id');
    } else {
      Metro.dialog.open('#' + this.idSnipper2);
    }
  }
  SnniperClose2(): void {
    if (this.idSnipper2 !== undefined) {
      Metro.dialog.toggle('#' + this.idSnipper2);
      this.idSnipper2 = undefined;
    }
  }

  SnniperClose(): void {
    if (this.idSnipper !== undefined) {
      Metro.dialog.toggle('#' + this.idSnipper);
      this.idSnipper = undefined;
    }
  }

  Snniper(): void {
    if (this.idSnipper === void 0) {
      var dialog: any = Metro.dialog.create({
        //  title: "",
        content: `<div data-role="activity" data-type="cycle" data-style="color"></div>`,
        width: 110,
        defaultAction: false,
        //actions: []
        //  options: {}
      });
      this.idSnipper = $(dialog['0']).attr('id');
    } else {
      Metro.dialog.open('#' + this.idSnipper);
    }
  }

  NotificacionSucess(
    mensaje: string,
    tittle: string = 'Transacción exitosa',
    keepOpen: boolean = false
  ): void {
    Metro.notify.create(mensaje.toString(), tittle, {
      cls: 'success',
      keepOpen: keepOpen,
    });
  }

  NotificacionSucess2(
    mensaje: string,
    tittle: string = 'Transacción exitosa',
    keepOpen: boolean = false
  ): void {
    Metro.notify.create(mensaje.toString(), tittle, {
      cls: 'success spinnerClass2',
      keepOpen: keepOpen,
    });
  }

  NotificacionAlert(mensaje: any, keepOpen: boolean = false): void {
    Metro.notify.create(mensaje.toString(), null, {
      cls: 'alert',
      keepOpen: keepOpen,
    });
  }

  NotificacionWarning(mensaje: string, keepOpen: boolean = false): void {
    Metro.notify.create(mensaje.toString(), null, {
      cls: 'warning',
      keepOpen: keepOpen,
    });
  }

  NotificacionInfo(mensaje: string, keepOpen: boolean = false): void {
    Metro.notify.create(mensaje.toString(), null, {
      cls: 'info',
      keepOpen: keepOpen,
    });
  }
}
